
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/voiture-sans-permis",
      function () {
        return require("private-next-pages/voiture-sans-permis/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/voiture-sans-permis"])
      });
    }
  